import store from '../store';

export default function (to, from, next) {
  if (store.state.user.accessToken) {
    next();
  } else {
    store.dispatch('user/resetState');
    next('/management');
  }
}
